import {
  Button,
  DatePicker,
  Form,
  notification,
  Select,
  Pagination,
  Empty,
  Input,
  Drawer,
  Row,
  Col,
  Switch,
} from "antd";
import locale from "antd/es/date-picker/locale/vi_VN";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
import $axios from "../../services/axios";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShuffle,
  faLocationDot,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import FilterBar from "../Common/FilterBar";
import ChooseCar from "../Common/ChooseCar";
import CarItem from "../Common/CarItem";
import CalendarCustom from "../Common/Calendar/CalendarCustom";
import "react-calendar/dist/Calendar.css";
import _ from "lodash";
const Booking = ({ setLoading, loading, setStep }) => {
  const [form] = Form.useForm();
  const [locations, setLocations] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [listTrip, setListTrip] = useState([]);
  const [totalTrip, setTotalTrip] = useState(0);
  const [area, setArea] = useState({});
  const [carSelected, setCarSelected] = useState(null);
  const [openChooseCar, setOpenChooseCar] = useState(false);
  const [searched, setSearched] = useState(false);
  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const [typeCalendar, setTypeCalendar] = useState("");
  const [minDateCalendar, setMinDateCalendar] = useState(new Date());
  const [tripType, setTripType] = useState("oneWay");
  const [filter, setFilter] = useState({
    addStart: "",
    addEnd: "",
    departDate: "",
    currentPage: 1,
    sort: "time:asc",
    fareMin: 0,
    fareMax: 2000000,
    ratingMin: 0,
    ratingMax: 5,
    timeMin: "00:00",
    timeMax: "23:59",
    availableSeatMin: 0,
    availableSeatMax: 50,
    onlineTicket: 1,
    // bộ lọc
    limousine: null,
    isPromotion: null,
    companies: [],
  });
  const [filterStatic, setFilterStatic] = useState(null);
  const [addPrice, setAddPrice] = useState(0);
  const [openDrawerChooseAdd, setOpenDrawerChooseAdd] = useState(false);
  const [nameField, setNameField] = useState("addStart");
  const [searchTerm, setSearchTerm] = useState("");
  const formRef = useRef(null);
  const [provinceDetect, setProvinceDetect] = useState("");

  useEffect(() => {
    detectLocation();
    getAreaCity();
    getAddPrice();
  }, []);

  useEffect(() => {
    if (provinces.length > 0 && provinceDetect) {
      const countryId = _.get(
        _.find(provinces, (c) => c.name === provinceDetect),
        "id",
        ""
      );
      if (countryId) {
        form.setFieldValue("addStart", countryId);
      }
    }
  }, [provinces, provinceDetect]);

  useEffect(() => {
    const prioritizedCities = ["Hà Nội", "Hồ Chí Minh"];
    const sortedProvinces = _.sortBy(
      _.filter(locations, (item) => {
        return (
          _.includes(_.toLower(item.name), _.toLower(searchTerm)) &&
          item.type === 3
        );
      }),
      (item) => {
        const index = prioritizedCities.indexOf(item.name);
        return index === -1 ? Infinity : index; // Nếu không trong danh sách ưu tiên, đặt sau cùng.
      }
    );
    setProvinces(sortedProvinces);
    setDistricts(
      _.filter(locations, (item) => {
        return (
          _.includes(_.toLower(item.name), _.toLower(searchTerm)) &&
          item.type !== 3
        );
      })
    );
  }, [searchTerm, locations]);

  const getAddPrice = async () => {
    try {
      const res = await $axios.$get(`/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        setAddPrice(_.get(res, "data.data.data.amount", 0));
      }
    } catch (error) {
    } finally {
    }
  };

  const handleGetFilterStatic = async (_filter) => {
    try {
      const res = await $axios.$get(
        `/vexe/statistic-routes?from=${_filter.addStart}&to=${
          _filter.addEnd
        }&date=${dayjs(_filter.departDate).format("YYYY-MM-DD")}&onlineTicket=${
          _filter.onlineTicket
        }&sort=${_filter.sort}&page=${_filter.currentPage}&pageSize=20`
      );
      setFilterStatic(res.data.data);
    } catch (error) {
      notification.error({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
    }
  };

  const handleGetListTrip = async (values) => {
    setSearched(true);
    const _filter = {
      addStart: Number(values.addStart),
      addEnd: Number(values.addEnd),
      departDate: values.departDate,
      sort: "time:asc",
      currentPage: 1,
      fareMin: 0,
      fareMax: 2000000,
      ratingMin: 0,
      ratingMax: 5,
      timeMin: "00:00",
      timeMax: "23:59",
      availableSeatMin: 0,
      availableSeatMax: 50,
      onlineTicket: 1,
      limousine: null,
      isPromotion: null,
      companies: [],
    };
    if (tripType === "roundTrip") {
      _filter.returnDate = values.returnDate;
    }
    setResetFilter(true);
    setFilter(_filter);
    handleGetFilterStatic(_filter);
    handleFindRoute(_filter);
  };

  const handleSwap = () => {
    const addStart = form.getFieldValue("addStart");
    const addEnd = form.getFieldValue("addEnd");
    form.setFieldValue("addEnd", addStart);
    form.setFieldValue("addStart", addEnd);
  };

  const handleFindRoute = async (_filter) => {
    setLoading(true);
    try {
      let urlFilter = `/vexe/routes?from=${_filter.addStart}&to=${
        _filter.addEnd
      }&date=${dayjs(_filter.departDate).format("YYYY-MM-DD")}&onlineTicket=${
        _filter.onlineTicket
      }&ratingMin=${_filter.ratingMin}&ratingMax=${_filter.ratingMax}&timeMin=${
        _filter.timeMin
      }&timeMax=${_filter.timeMax}&fareMin=${_filter.fareMin}&fareMax=${
        _filter.fareMax
      }&availableSeatMin=${_filter.availableSeatMin}&availableSeatMax=${
        _filter.availableSeatMax
      }&sort=${_filter.sort}&page=${_filter.currentPage}&pageSize=20`;
      if (!_.isNil(_filter.limousine)) {
        urlFilter += `&limousine=${_filter.limousine}`;
      }
      if (!_.isNil(_filter.isPromotion)) {
        urlFilter += `&isPromotion=${_filter.isPromotion}`;
      }
      if (!_.isNil(_filter.companies && _filter.companies.length > 0)) {
        _.forEach(_filter.companies, (c) => {
          urlFilter += `&companies=${c}`;
        });
      }

      const res = await $axios.$get(urlFilter);
      setListTrip(res.data.data.data);
      setTotalTrip(res.data.data.total);
      setArea(res.data.data.area);
    } catch (error) {
      notification.error({
        status: "error",
        message: "Thất bại!",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  // Hàm phát hiện tỉnh/thành phố
  const detectLocation = async () => {
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLoading(true);
        try {
          // Thay YOUR_API_KEY bằng Google Maps API Key của bạn
          const apiKey = "AIzaSyDjg6691DQySNdPewrzG66RJmxZNuLUjKw";
          const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}&language=vi`;

          const response = await axios.get(url);
          const results = response.data.results;

          if (results.length === 0) {
            console.error("No location data found.");
            return;
          }

          // Tìm thông tin tỉnh/thành phố
          const province = results[0].address_components.find((component) =>
            component.types.includes("administrative_area_level_1")
          );
          setProvinceDetect(_.get(province, "long_name", ""));
        } catch (error) {
          console.error("Error fetching location data:", error);
        } finally {
          setLoading(false);
        }
      },
      (error) => {
        console.error("Error getting geolocation:", error.message);
      }
    );
  };

  const getAreaCity = async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(`/vexe/area/city_district`);
      setLocations(res.data.data);
      const prioritizedCities = ["Hà Nội", "Hồ Chí Minh"];
      const sortedProvinces = _.sortBy(
        _.filter(res.data.data, (item) => item.type === 3),
        (item) => {
          const index = prioritizedCities.indexOf(item.name);
          return index === -1 ? Infinity : index; // Nếu không trong danh sách ưu tiên, đặt sau cùng.
        }
      );
      setProvinces(sortedProvinces);
      setDistricts(_.filter(res.data.data, (item) => item.type !== 3));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onOpenChange = (type) => {
    setValueCalendar(form.getFieldValue(type) ?? new Date());
    setOpenCalendar(true);
    setTypeCalendar(type);
    if (type === "returnDate") {
      setMinDateCalendar(new Date(form.getFieldValue("departDate")));
    } else {
      setMinDateCalendar(new Date());
    }
  };

  const setValue = (value) => {
    form.setFieldValue(typeCalendar, dayjs(value));
    setValueCalendar(value);
    setOpenCalendar(false);
  };

  const handleSelectAdd = (value) => {
    form.setFieldValue(nameField, value);
    setOpenDrawerChooseAdd(false);
    setSearchTerm("");
  };

  return (
    <div className="flex flex-col items-center mt-[0px] booking bg-white left-1/2 transform -translate-x-1/2 w-[92%] rounded-[12px] relative top-[120px]">
      {/* w-[90%] mx-auto absolute top-[30px] left-1/2 transform -translate-x-1/2
      flex flex-col */}
      <CalendarCustom
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
        typeCalendar={typeCalendar}
        form={form}
        valueCalendar={valueCalendar}
        setValue={setValue}
        minDate={minDateCalendar}
      />
      <Form
        form={form}
        ref={formRef}
        onFinish={handleGetListTrip}
        layout="vertical"
        onFinishFailed={(values) => {
          console.log(values, "values");
        }}
        initialValues={{
          departDate: dayjs(),
        }}
        className="w-full"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 rounded-2xl"
          >
            <Row
              gutter={0}
              className="items-center w-full mb-4"
              justify={"space-between"}
            >
              <Col span={10} style={{ paddingRight: 0 }}>
                <div className="text-[14px] font-medium text-secondary mb-1">
                  Điểm đi
                </div>
                <Form.Item
                  name="addStart"
                  rules={[
                    { required: true, message: "Điểm đi không được để trống!" },
                  ]}
                  className="w-full mb-0 no-required-mark"
                >
                  <Select
                    showSearch={false}
                    open={false}
                    optionFilterProp="name"
                    placeholder="Điểm đi"
                    fieldNames={{ value: "id", label: "name" }}
                    className="h-[48px]"
                    suffixIcon={
                      <svg
                        className="text-primary"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.49997 13.3845C11.0931 13.3845 12.3846 12.093 12.3846 10.4998C12.3846 8.90672 11.0931 7.61523 9.49997 7.61523C7.90684 7.61523 6.61536 8.90672 6.61536 10.4998C6.61536 12.093 7.90684 13.3845 9.49997 13.3845Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <circle
                          cx="9.5"
                          cy="10.5"
                          r="6.75"
                          stroke="currentColor"
                          stroke-width="1.5"
                        />
                      </svg>
                    }
                    // labelRender={(props) => (
                    //   <span className="text-secondary">
                    //     {locations.find((item) => item.id === props.value)?.name ||
                    //       ""}
                    //   </span>
                    // )}
                    onClick={() => {
                      setOpenDrawerChooseAdd(true);
                      setNameField("addStart");
                    }}
                    options={locations}
                  />
                </Form.Item>
              </Col>
              <Col span={4} className="flex items-center justify-center">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer text-primary mt-8"
                  onClick={() => handleSwap()}
                >
                  <circle
                    cx="16"
                    cy="16"
                    r="15.5"
                    fill="white"
                    stroke="currentColor"
                  />
                  <path
                    d="M17.0678 13.5192C16.7798 13.2312 16.7797 12.7641 17.0678 12.476L20.1842 9.35893C20.4722 9.07084 20.9393 9.07077 21.2274 9.35883L17.0678 13.5192ZM17.0678 13.5192C17.3559 13.8073 17.823 13.8072 18.111 13.5191L19.9684 11.6613L19.9695 22.3477C19.9696 22.755 20.2999 23.0853 20.7072 23.0852C21.1146 23.0852 21.4448 22.7549 21.4448 22.3475L21.4437 11.6612L23.3014 13.5185C23.5895 13.8066 24.0566 13.8065 24.3446 13.5184C24.4886 13.3744 24.5606 13.1854 24.5606 12.9968C24.5606 12.8082 24.4885 12.6192 24.3445 12.4753L21.2274 9.35883L17.0678 13.5192Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.4928 18.7088C15.7808 18.9968 15.7809 19.4639 15.4928 19.752L12.3764 22.8691C12.0884 23.1572 11.6213 23.1573 11.3332 22.8692L15.4928 18.7088ZM15.4928 18.7088C15.2047 18.4207 14.7376 18.4208 14.4496 18.7089L12.5922 20.5667L12.5911 9.8803C12.591 9.47299 12.2607 9.1427 11.8534 9.14282C11.446 9.14282 11.1158 9.4731 11.1158 9.88053L11.1169 20.5668L9.25917 18.7095C8.9711 18.4215 8.50402 18.4215 8.21598 18.7096C8.07202 18.8536 7.99998 19.0426 8 19.2312C8.00002 19.4198 8.0721 19.6088 8.21614 19.7527L11.3332 22.8692L15.4928 18.7088Z"
                    fill="currentColor"
                  />
                </svg>
              </Col>
              <Col span={10} style={{ paddingRight: 0 }}>
                <div className="text-[14px] font-medium text-secondary mb-1">
                  Điểm đến
                </div>
                <Form.Item
                  name="addEnd"
                  rules={[
                    {
                      required: true,
                      message: "Điểm đến không được để trống!",
                    },
                  ]}
                  className="w-full mb-0"
                >
                  <Select
                    showSearch={false}
                    open={false}
                    optionFilterProp="name"
                    placeholder="Điểm đến"
                    fieldNames={{ value: "id", label: "name" }}
                    className="h-[48px]"
                    suffixIcon={
                      <svg
                        className="text-primary"
                        width="16"
                        height="20"
                        viewBox="0 0 16 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </svg>
                    }
                    // labelRender={(props) => (
                    //   <span className="text-secondary">
                    //     {locations.find((item) => item.id === props.value)?.name ||
                    //       ""}
                    //   </span>
                    // )}
                    onClick={() => {
                      setOpenDrawerChooseAdd(true);
                      setNameField("addEnd");
                    }}
                    options={locations}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="flex items-center justify-between w-full mb-2">
              <label className="font-medium text-secondary">Ngày đi</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={tripType === "roundTrip"}
                  onChange={(checked) => {
                    setTripType(checked ? "roundTrip" : "oneWay");
                  }}
                  type="primary"
                />{" "}
                <label className="font-medium text-secondary">Khứ hồi</label>
              </div>
            </div>
            <Row
              gutter={0}
              className="items-center w-full mb-0 mt-2"
              justify={"space-between"}
            >
              <Col
                span={tripType === "roundTrip" ? 12 : 24}
                style={{ paddingRight: tripType === "roundTrip" ? 14 : 0 }}
              >
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn ngày đi!",
                    },
                  ]}
                  name="departDate"
                  className="w-full mb-4"
                >
                  <DatePicker
                    className="w-full h-[48px]"
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    allowClear={false}
                    locale={locale} // Thiết lập locale tiếng Việt
                    suffixIcon={
                      <svg
                        className="text-primary"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_120_8739)">
                          <path
                            d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_120_8739">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    }
                    open={false}
                    onOpenChange={() => onOpenChange("departDate")}
                  />
                </Form.Item>
              </Col>
              {tripType === "roundTrip" && (
                <Col span={12} style={{ paddingLeft: 14 }}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn ngày về!",
                      },
                    ]}
                    name="returnDate"
                    className="w-full mb-4"
                  >
                    <DatePicker
                      className="w-full h-12"
                      placeholder="Chọn ngày"
                      format="DD/MM/YYYY"
                      minDate={dayjs()}
                      allowClear={false}
                      locale={locale} // Thiết lập locale tiếng Việt
                      suffixIcon={
                        <svg
                          className="text-primary"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_120_8739)">
                            <path
                              d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                              fill="currentColor"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_120_8739">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      }
                      open={false}
                      onOpenChange={() => onOpenChange("returnDate")}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Button
              className="w-full h-[48px] my-4 bg-primary hover:bg-primary"
              type="primary"
              onClick={() => {
                formRef.current.submit();
              }}
            >
              <span className="text-[16px] font-semibold">Tìm vé xe</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>

      <div className="text-center mt-4">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>
      {filterStatic && (
        <FilterBar
          filter={filter}
          setFilter={setFilter}
          handleFindRoute={handleFindRoute}
          filterStatic={filterStatic}
          resetFilter={resetFilter}
          setResetFilter={setResetFilter}
        />
      )}
      {listTrip && listTrip.length > 0 ? (
        <>
          <div className="mt-4 w-full">
            {listTrip.map((item, index) => (
              <CarItem
                key={index}
                setOpenChooseCar={setOpenChooseCar}
                data={item}
                setCarSelected={setCarSelected}
                addPrice={addPrice}
                area={area}
              />
            ))}
          </div>
          <Pagination
            current={filter.currentPage}
            className="my-4"
            total={totalTrip}
            onChange={(page) => {
              const _filter = { ...filter, currentPage: page };
              setFilter(_filter);
              handleFindRoute(_filter);
            }}
            pageSize={20}
            showSizeChanger={false}
            showQuickJumper={false}
          />
        </>
      ) : (
        <>
          {!loading && searched && (
            <div className="flex flex-col w-full items-center mt-[48px]">
              <div className="text-[24px] text-primary font-bold text-center mb-3">
                Không tìm thấy chuyến trên Ipass
              </div>
              <div className="mb-4 text-center text-primary">
                Hiện tại <span className="font-bold">Ipass</span> chưa cập nhật
                đơn hàng của tuyến{" "}
                <span className="font-bold">
                  {area?.from?.name} - {area?.to?.name} ngày{" "}
                  {dayjs(filter.departDate).format("DD-MM-YYYY")}
                </span>
              </div>
              <div className="mb-4 text-center text-primary">
                Xin quý khách vui lòng tìm chuyến với ngày khởi hành khác hoặc
                thay đổi tuyến đường tìm kiếm.
              </div>
              {/* <img
            src="/images/route-no-schedule.png"
            alt=""
            srcset=""
            className="max-w-[100%]"
          /> */}
              <Empty description={""} />
            </div>
          )}
        </>
      )}
      {openChooseCar && (
        <ChooseCar
          carSelected={carSelected}
          open={openChooseCar}
          addPrice={addPrice}
          setOpenChooseCar={setOpenChooseCar}
          setLoading={setLoading}
          setCarSelected={setCarSelected}
          area={area}
          tripType={tripType}
          filterSearch={filter}
        />
      )}
      {openDrawerChooseAdd && (
        <div className="location">
          <Drawer
            title={
              <h1 className="text-lg font-bold text-white">
                Chọn điểm {nameField === "addStart" ? "đi" : "đến"}
              </h1>
            }
            placement="bottom"
            open={openDrawerChooseAdd}
            onClose={() => {
              setOpenDrawerChooseAdd(false);
            }}
            height="100vh"
          >
            <div className="custom-scroll pb-[64px]">
              <Input
                placeholder="Tìm kiếm địa điểm"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                }}
                className="mb-4"
              />

              <div className="overflow-auto airport-list">
                {!!provinces.length && (
                  <>
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Tỉnh/Thành (trực thuộc Trung ương)
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {provinces.map((item) => (
                        <div
                          key={item.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#F5F8FC]"
                          onClick={() => handleSelectAdd(item.id)}
                        >
                          {item?.name}
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {!!districts.length && (
                  <div className="mt-4">
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Quận/Huyện/Thị trấn/Thành phố (trực thuộc tỉnh)
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {districts.map((item) => (
                        <div
                          key={item.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#F5F8FC]"
                          onClick={() => handleSelectAdd(item.id)}
                        >
                          {item?.name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default Booking;
